import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/gradeActions";
import { format, setHours, setMinutes, setSeconds } from "date-fns";
import { PencilSquareIcon } from "@heroicons/react/20/solid";

const GradeRow = ({ grade, gradeSetOpenModal, currency }) => {
	console.log("inRow", grade);

	const everyOptions = [
		{ value: "105", label: "Hour" },
		{ value: "104", label: "Day" },
		{ value: "103", label: "Week" },
		{ value: "102", label: "Month" },
		{ value: "101", label: "Year" },
	];

	const salaryFrequency =
		grade?.salary?.salaryPeriod &&
		everyOptions.find((item) => item && item.value == grade.salary.salaryPeriod)?.label;
	const gradeSalary = parseFloat(grade?.salary?.salaryAmount).toLocaleString(undefined, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});

	return (
		<tr>
			<td className="text-center">
				<div>
					<a
						className="btn btn-xs btn-default"
						onClick={() => {
							gradeSetOpenModal(true, grade);
						}}
					>
						<PencilSquareIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</a>
				</div>
			</td>
			<td>{grade.name}</td>
			<td>
				{currency}
				{gradeSalary}/{salaryFrequency}
			</td>
			<td>{grade.updatedAt && format(new Date(grade.updatedAt), "dd/MM/yyyy")}</td>
		</tr>
	);
};


const mapStateToProps = (state) => {
  console.log('state', state && state.grades)
  return {
    currency: state.company?.settings?.currency
  }
}

const mapDispatchToProps = dispatch => ({
  gradeSetOpenModal: (status, grade) => dispatch(ACTIONS.gradeSetOpenModal(status, grade)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GradeRow) 